// extracted by mini-css-extract-plugin
module.exports = {"trainingRibbon":"styles_trainingRibbon__1wNoX","archivedRibbon":"styles_archivedRibbon__2bydZ"};